module.exports = __webpack_public_path__ + "static/media/dutch-language-sphere.a5230419.svg";